import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DevUtilService {

  constructor(public http: HttpClient,public toast: ToastrService,private auth: AuthService) {}

  dropSearchSeed(id: number){
    return this.http.get(environment.baseURl + `/api/values/sps/${id}`);
  }
}
